import type { StickerIllustrationProps } from '../Sticker';

export const RecStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="45"
      cy="45"
      r="39.375"
      transform="rotate(180 45 45)"
      fill="#BA0C2F"
      stroke="white"
      strokeWidth="5.625"
    />
    <path
      d="M37.6875 70.0786C41.8298 70.8809 46.1061 70.7446 50.1857 69.6801C54.2652 68.6157 58.0386 66.6517 61.214 63.94C64.3894 61.2283 66.8816 57.8416 68.4978 54.0419C70.1141 50.2423 70.811 46.1315 70.5348 42.0276C70.2586 37.9237 69.0165 33.9367 66.9048 30.375"
      stroke="#F1CED5"
      strokeWidth="5.625"
      strokeLinecap="round"
    />
  </svg>
);
